import type { Bounds, Point } from '../state/types';

const SELECTION_COLOR = '#0066ff';
const HANDLE_RADIUS = 6;

export function getViewportScale(ctx: CanvasRenderingContext2D): number {
  const dpr = window.devicePixelRatio || 1;
  return ctx.getTransform().a / dpr;
}

export const renderSelection = (
  ctx: CanvasRenderingContext2D,
  bounds: Bounds,
  handlePoints: Point[],
  _handleSize: number
): void => {
  const scale = getViewportScale(ctx);
  ctx.save();

  // Dashed bounding box
  ctx.strokeStyle = SELECTION_COLOR;
  ctx.lineWidth = 2 / scale;
  ctx.setLineDash([5 / scale, 5 / scale]);
  ctx.strokeRect(bounds.x, bounds.y, bounds.width, bounds.height);
  ctx.setLineDash([]);

  // Handle circles
  for (const point of handlePoints) {
    ctx.fillStyle = '#ffffff';
    ctx.strokeStyle = SELECTION_COLOR;
    ctx.lineWidth = 2 / scale;
    ctx.beginPath();
    ctx.arc(point.x, point.y, HANDLE_RADIUS / scale, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();
  }

  ctx.restore();
};
